import React from 'react';
import Reveal from './Reveal';
import { scrollToSection } from '../utils/scrollToSection';

const PRINCIPLES = [
  'Individuální přístup ke každému případu',
  'Otevřená a srozumitelná komunikace',
  'Transparentní podmínky spolupráce',
];

export default function About() {
  return (
    <section id="o-mně" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal className="mx-auto w-full max-w-md lg:mx-0 lg:max-w-none">
            <div className="relative">
              <div
                className="about-frame absolute -left-3 -top-3 h-full w-full border border-bronze/40 sm:-left-4 sm:-top-4"
                aria-hidden="true"
              ></div>
              <img
                src="/image.png"
                alt="Mgr. et Bc. Lenka Ježková, advokátka v Chlumci nad Cidlinou"
                className="relative w-full object-cover"
              />
            </div>
            <p className="mt-6 text-sm text-slate-500">
              Mgr. et Bc. Lenka Ježková, advokátka zapsaná u České advokátní
              komory pod ev. č. 12271
            </p>
          </Reveal>

          <Reveal delay={150}>
            <p className="mb-3 text-xs uppercase tracking-[0.25em] text-bronze sm:text-sm">
              O advokátce
            </p>
            <h2 className="font-serif text-3xl text-ink sm:text-4xl">
              Mgr. et Bc. Lenka Ježková
            </h2>

            <div className="mt-6 space-y-4 text-base leading-relaxed text-slate-600 sm:text-lg">
              <p>
                V advokacii působím více než dvacet let. Klientům poskytuji
                právní služby především v oblasti rodinného, trestního,
                pracovního a občanského práva.
              </p>
              <p>
                Ke každému případu přistupuji individuálně. Záleží mi na tom,
                aby klient vždy rozuměl tomu, co se v jeho věci děje, znal svá
                práva a možnosti dalšího postupu.
              </p>
              <p>
                Kancelář sídlí v Chlumci nad Cidlinou a služby poskytuji
                klientům z celého okolí. K zastižení jsem sedm dní v týdnu.
              </p>
            </div>

            <ul className="mt-8 space-y-3">
              {PRINCIPLES.map((principle) => (
                <li key={principle} className="flex items-start gap-3">
                  <span
                    className="mt-[11px] block h-px w-6 shrink-0 bg-bronze"
                    aria-hidden="true"
                  ></span>
                  <span className="text-base text-ink/90">{principle}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => scrollToSection('kontakt')}
              className="mt-10 w-full bg-ink px-7 py-3.5 text-base font-medium text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-ink-soft active:translate-y-0 sm:w-auto"
            >
              Sjednat konzultaci
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
